import { Gender } from "components/identity/IdentityBirthGenderForm";

/**
 * 생년월일(yyyyMMdd) + 성별 + 외국인 여부 → 주민번호/외국인등록번호 뒷자리 첫번째 (1~8)
 *   내국인:
 *     - 1900년대 + 남 = "1", 여 = "2"
 *     - 2000년대 + 남 = "3", 여 = "4"
 *   외국인 (국내 거주, ARC 보유 + KR 통신사):
 *     - 1900년대 + 남 = "5", 여 = "6"
 *     - 2000년대 + 남 = "7", 여 = "8"
 *
 * KR 다날 본인인증 호출 시 필수. MALE/FEMALE 외 값(OTHER, "") 진입은
 * 상위 단계 (Step2 / RecoverStep1) 에서 차단되어야 하며, 진입 시 즉시 throw 하여
 * silent 한 잘못된 호출을 방지한다.
 */
export const getKrGenderDigit = (birth: string, gender: Gender, isForeigner: boolean = false): string => {
    if (gender !== "MALE" && gender !== "FEMALE") {
        throw new Error(`getKrGenderDigit: KR 다날 인증은 MALE/FEMALE 만 허용 (gender=${gender || "''"})`);
    }
    if (!/^\d{8}$/.test(birth)) {
        throw new Error(`getKrGenderDigit: birth 는 yyyyMMdd 8자리 숫자여야 함 (birth=${birth})`);
    }
    const birthYear = parseInt(birth.substring(0, 4), 10);
    const isMale = gender === "MALE";
    if (isForeigner) {
        if (birthYear >= 2000) return isMale ? "7" : "8";
        return isMale ? "5" : "6";
    }
    if (birthYear >= 2000) return isMale ? "3" : "4";
    return isMale ? "1" : "2";
};
